import { render, staticRenderFns } from "./OrderDurationChart.vue?vue&type=template&id=648ffaa6&"
import script from "./OrderDurationChart.vue?vue&type=script&lang=js&"
export * from "./OrderDurationChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports